<template>
<div><p>广告推广</p></div>
</template>

<script>
  export default {
    name: "advertisement"
  }
</script>

<style scoped>

</style>
